import BeddingSection from './BeddingSection';

export default BeddingSection;
